import {
  Component, OnDestroy, Input, Output, ViewChild, EventEmitter,
  ElementRef, AfterViewInit, OnChanges, SimpleChanges, HostListener
} from '@angular/core';

@Component({
  selector: 'app-infinite-scroll',
  template: `<ng-content></ng-content><div #anchor></div>`,
})
export class InfiniteScrollComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() options = {};
  @Input() dataUpdated = false;
  @Output() scrolled = new EventEmitter<number>();
  @ViewChild('anchor', { static: false }) anchor: ElementRef;

  private observer: any;
  private isIntersecting = false;
  private reCheckInterval;

  constructor(private host: ElementRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataUpdated && this.isIntersecting) {
      const posFromBottom = window.innerHeight - this.anchor.nativeElement.offsetTop;
      this.scrolled.emit(posFromBottom);
    }
  }

  ngAfterViewInit() {
    const options = {
      root: this.isHostScrollable() ? this.host.nativeElement : null,
      ...this.options
    };

    this.observer = new IntersectionObserver(([entry]) => {
      this.isIntersecting = entry.isIntersecting;
      if (entry.isIntersecting) {
        const posFromBottom = window.innerHeight - this.anchor.nativeElement.offsetTop;
        this.scrolled.emit(posFromBottom);
      }
    }, options);

    this.observer.POLL_INTERVAL = 100; // Time in milliseconds.

    this.observer.observe(this.anchor.nativeElement);

    this.reCheckInterval = setInterval(() => {
      if (this.isIntersecting) {
        const posFromBottom = window.innerHeight - this.anchor.nativeElement.offsetTop;
        this.scrolled.emit(posFromBottom);
      }
    }, 1000);
  }

  ngOnDestroy() {
    this.observer.disconnect();
    clearInterval(this.reCheckInterval);
  }

  private isHostScrollable() {
    const style = window.getComputedStyle(this.element);

    return style.getPropertyValue('overflow') === 'auto' ||
      style.getPropertyValue('overflow-y') === 'scroll';
  }

  get element() {
    return this.host.nativeElement;
  }
}
